<script setup>
import { ref, onMounted } from 'vue'

import RadioButtonGroup from './RadioButtonGroup.vue'
import SelectGroup from './SelectGroup.vue'
import LibraryInputs from './LibraryInputsSample.vue'
import LibraryTooltip from './LibraryTooltipSample.vue'
import LibraryTabs from './LibraryTabsSample.vue'
import Icons from './Icons.vue'
import LibraryButtons from './LibraryButtonsSample.vue'
import LibraryMenus from './LibraryMenusSample.vue'
import LibraryCards from './LibraryCardsSample.vue'
import LibraryDialogs from './LibraryDialogsSample.vue'
import LibrarySelectionChip from './LibrarySelectionChipSample.vue'
import SubmitFeedback from '@/components/SubmitFeedback.vue'
import LibraryAnalytics from '@/componentlibrary/LibraryAnalyticsSample.vue'
import { useUserFeedbackContext } from '@/components/useUserFeedbackContext'

// Update feedback context for the SubmitFeedback component
const { updateContext } = useUserFeedbackContext()

onMounted(() => {
  updateContext({
    uuid: 'component-lib-123',
    title: 'Component Library Page',
    subject: 'Reading'
  })
})

const filterGroup = ref([
  { label: 'Letter/Sound Identification', value: 'LSI' },
  { label: 'High Frequency Word Reading', value: 'HFWR' },
  { label: 'Phonics & Decoding', value: 'P&D' },
  { label: 'Fluency', value: 'fluency' }
])

const subjectGroup = ref([
  { label: 'Reading', value: 'reading' },
  { label: 'Math', value: 'math' },
  { label: 'Writing', value: 'writing' },
  { label: 'Behavior', value: 'behavior' }
])

const selectedCategory = ref('')
const selectedSubject = ref('')
</script>

<template>
  <div class="container mx-auto grid grid-cols-4">
    <div
      class="rounded my-6 min-w-fit border border-gray-400 bg-gray-100 px-6 py-6 font-default shadow-md"
    >
      <RadioButtonGroup
        v-model="selectedCategory"
        :filterGroup="filterGroup"
        groupLabel="Categories"
        highlightColor="bg-purple-300"
      />
      <SelectGroup
        v-model="selectedSubject"
        :filterGroup="subjectGroup"
        groupLabel="Subjects"
        placeholder="Choose a subject"
      />
    </div>
  </div>

  <div class="container py-6">
    <h2 class="header-lg">Tooltips</h2>
    <LibraryTooltip />
  </div>
  <hr />
  <div class="container py-6">
    <h2 class="header-lg">Text Inputs</h2>
    <div class="w-6/12"><LibraryInputs /></div>
  </div>
  <hr />
  <div class="container py-6">
    <h2 class="header-lg">Tabs</h2>
    <LibraryTabs />
  </div>
  <hr />
  <div class="container py-6">
    <h2 class="header-lg">Icons</h2>
    <Icons />
  </div>
  <hr />
  <div class="container py-6">
    <h2 class="header-lg">Buttons</h2>
    <LibraryButtons />
  </div>
  <hr />
  <div class="container py-6">
    <h2 class="header-lg">Menus</h2>
    <LibraryMenus />
  </div>
  <hr />
  <div class="container py-6">
    <h2 class="header-lg">Cards</h2>
    <LibraryCards />
  </div>
  <hr />
  <div class="container py-6">
    <h2 class="header-lg" id="menus">Dialogs</h2>
    <LibraryDialogs />
  </div>
  <hr />
  <div class="container py-6">
    <h2 class="header-lg" id="selectionchip">Selection Chips</h2>
    <LibrarySelectionChip />
  </div>
  <div class="container py-6">
    <h2 class="header-lg" id="analytics">Analytics Event Testing</h2>
    <LibraryAnalytics />
  </div>
  <hr />
  <div class="container py-6">
    <h2 class="header-lg" id="submitfeedback">Submit Feedback Button</h2>
    <p class="mb-4">
      The SubmitFeedback component is rendered in App.vue and uses feedback context that this page updates on mount.
      The context values (uuid: 'component-lib-123', title: 'Component Library Page', subject: 'Reading') 
      are automatically picked up by the feedback button at the bottom of the page.
    </p>
  </div>
</template>
